/**
 * Settings → Members: who is in this project and with what role. Those with
 * `members:write` add people by email, change roles and remove people, offering
 * only roles up to their own; a member may add annotators; everyone else sees a
 * read-only list. The server has the last word (it refuses, say, removing the
 * last owner) and its message is shown as is.
 */

import { Box } from "@/components/ui/box";
import { EmptyState, QueryState } from "@/components/ui/states";
import { useMembers, useProject } from "@/features/projects/hooks";
import { AddMemberForm } from "./add-member-form";
import { isOnlyOwner } from "./leave-project-button";
import { MemberRow } from "./member-row";

export function MembersTab() {
  const { project, can } = useProject();
  const members = useMembers();
  const myRole = project && can("members:write") ? project.role : null;
  return (
    <>
      {myRole && (
        <p className="text-[13px] text-muted">
          Add anyone with a qure.ai email. They see this project as soon as they sign in. We don't send an
          email, so share the link with them.
        </p>
      )}
      <Box>
        {myRole && <AddMemberForm myRole={myRole} />}
        <QueryState query={members} what="members">
          {members.data?.length ? (
            <div className="overflow-x-auto">
              <table className="tbl">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Last seen</th>
                    <th aria-label="Actions" />
                  </tr>
                </thead>
                <tbody>
                  {members.data.map((m) => (
                    <MemberRow
                      key={m.email}
                      member={m}
                      myRole={myRole}
                      onlyOwner={isOnlyOwner(m, members.data)}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <EmptyState title="No members">Nobody holds a role in this project yet.</EmptyState>
          )}
        </QueryState>
      </Box>
    </>
  );
}
